import cn from 'classnames';
import { memo } from 'react';
import { useLocation } from 'react-router';

import { setNbsp } from '../../utils/setNbsp';
import classes from './career-card.module.scss';

interface ICareerCardProps {
  title?: string;
  subtitle?: string;
  image?: React.ReactNode;
  idx: number;
}

function CareerCard({
  title, subtitle, image, idx,
}: ICareerCardProps) {
  const location = useLocation();
  return (
    <div className={classes.cardWrapper}>
      <div
        className={cn({
          [classes.card]: true,
          [classes.mainPageCard]: location.pathname === '/',
        })}
      >
        <h2>{title}</h2>
        <p>{setNbsp(subtitle || '')}</p>
      </div>
      {image && (
        <div
          className={cn(
            classes.cardImage,
            classes[`cardImage__${idx % 2 ? 'horizontal' : 'vertical'}`],
          )}
          style={{
            background: `url(${image})  40% 55% / cover no-repeat`,
            backgroundSize: 'cover',
          }}
        />
      )}
    </div>
  );
}

export default memo(CareerCard);
